import web1Img from '../assets/images/web1.png';
import web2Img from '../assets/images/web2.png';
import web3Img from '../assets/images/web3.png';
import web4Img from '../assets/images/web4.png';
import web5Img from '../assets/images/web5.png';
import web6Img from '../assets/images/web6.png';
import contact1Img from '../assets/images/contact1.png';
import contact3Img from '../assets/images/contact3.png';
import contact4Img from '../assets/images/contact4.png';
import about1Img from '../assets/images/about1.png';
import about2Img from '../assets/images/about2.png';
import about3Img from '../assets/images/about3.png';
import process1Img from '../assets/images/process1.png';
import process2Img from '../assets/images/process2.png';

export const blogCategories = [
  'ALL',
  'BUSINESS',
  'CLIENT STORIES',
  'DESIGN',
  'SEO',
  'WALLPAPER',
  'WELLNESS'
];

export const blogPosts = [
  {
    id: 'how-to-curate-images-for-wellness-website',
    slug: 'how-to-curate-images-for-wellness-website',
    title: 'How to Curate Images for Your Wellness Website Like a Pro',
    category: 'DESIGN',
    date: 'AUGUST 18, 2026',
    featuredImage: web1Img,
    excerpt: 'Selecting the right photography for your wellness brand makes all the difference. Learn how to choose visuals that evoke calm and trust.',
    content: [
      "Visual storytelling plays a pivotal role in creating a tranquil, professional presence for your wellness business. When visitors arrive at your website, your images communicate your brand's atmosphere before they read a single line of copy.",
      "Start by defining your color palette and texture preferences. Warm earth tones, soft organic light, and un-cluttered compositions instantly create a sense of grounding and authenticity.",
      "Mix lifestyle imagery with detail shots. Pair a welcoming photo of your studio space with close-ups of natural materials like linen, stone, or botanical elements to craft an elevated narrative."
    ],
    prevPost: {
      slug: 'proven-marketing-strategies-for-holistic-nutritionist',
      title: 'PROVEN MARKETING STRATEGIES TO ATTRACT CLIENTS AS A HOLISTIC NUTRITIONIST'
    },
    nextPost: {
      slug: 'july-iphone-wallpaper-sun-summer-self-care',
      title: 'JULY IPHONE WALLPAPER: SUN, SUMMER, SELF CARE'
    }
  },
  {
    id: 'july-iphone-wallpaper-sun-summer-self-care',
    slug: 'july-iphone-wallpaper-sun-summer-self-care',
    title: 'July iPhone Wallpaper: Sun, Summer, Self Care',
    category: 'WALLPAPER',
    date: 'AUGUST 16, 2026',
    featuredImage: contact3Img,
    excerpt: 'Free downloadable aesthetic phone wallpapers designed to bring warm sunlight and calm summer vibes to your daily screen.',
    content: [
      "July always feels like one of the busiest months of the year. It gets full fast, but in a good way. Vacations, beach days, birthdays, road trips, backyard barbecues, all of it stacked on top of each other in the best kind of chaos. Everything's moving, everything's happening, and sometimes it feels like you blink and the whole summer is already over.",
      "That's kind of what inspired this month's wallpaper collection — this idea of trying to hold onto it a little longer. To actually feel the days instead of just racing through them. These wallpapers are like reminders to notice what's happening as it's happening. The golden light, the way cold fruit tastes on a hot day, the sound of kids playing outside, how it feels to be really present — even just for a second.",
      "The background for these wallpapers is the surface of the water catching the light. That soft and fleeting shimmer has always been one of those moments that makes me stop. It's simple, but I love how it feels like everything slows down when I see it. I always take a mental screenshot when I see it (and often a real one too) so I can hold onto it in my memory like a little keepsake. That's really where this collection started. I wanted to take that one small, peaceful second and turn it into something you could carry around with you.",
      "There are four versions of this July iPhone wallpaper. One is a calendar because let's be honest, July tends to fly by and sometimes it's nice to see the days laid out. One's a reminder of all the tiny things that make this season magic. One says \"sun, summer, self-care\" — a gentle cue to come back to yourself, even in the middle of the rush. And the last one, \"sunshine is everything,\" is just that pure, happy truth. Pick the one that fits your mood, or change them up as the month unfolds.",
      "I hope one of these finds its way to your screen this month, and maybe helps you hold onto the moments that matter — just a little longer."
    ],
    prevPost: {
      slug: 'proven-marketing-strategies-for-holistic-nutritionist',
      title: 'PROVEN MARKETING STRATEGIES TO ATTRACT CLIENTS AS A HOLISTIC NUTRITIONIST'
    },
    nextPost: {
      slug: 'how-to-curate-images-for-wellness-website',
      title: 'HOW TO CURATE IMAGES FOR YOUR WELLNESS WEBSITE LIKE A PRO'
    }
  },
  {
    id: 'proven-marketing-strategies-for-holistic-nutritionist',
    slug: 'proven-marketing-strategies-for-holistic-nutritionist',
    title: 'Proven Marketing Strategies to Attract Clients as a Holistic Nutritionist',
    category: 'BUSINESS',
    date: 'JULY 28, 2026',
    featuredImage: web2Img,
    excerpt: 'Discover organic marketing practices to connect deeply with clients seeking authentic holistic health support.',
    content: [
      "Building a successful practice as a holistic nutritionist requires a blend of clear messaging, authentic client connections, and an inviting online space.",
      "Focus on education-led content. Sharing recipes, seasonal wellness tips, and practical client case studies builds trust before a potential client ever schedules a consultation."
    ],
    prevPost: {
      slug: 'july-iphone-wallpaper-sun-summer-self-care',
      title: 'JULY IPHONE WALLPAPER: SUN, SUMMER, SELF CARE'
    },
    nextPost: {
      slug: 'how-to-curate-images-for-wellness-website',
      title: 'HOW TO CURATE IMAGES FOR YOUR WELLNESS WEBSITE LIKE A PRO'
    }
  },
  {
    id: 'essential-seo-tips-for-creative-studios',
    slug: 'essential-seo-tips-for-creative-studios',
    title: 'Essential SEO Strategies for Creative Studios and Designers',
    category: 'SEO',
    date: 'JULY 15, 2026',
    featuredImage: web3Img,
    excerpt: 'Simple yet powerful SEO optimizations to help your creative business get found on Google without technical overwhelm.',
    content: [
      "Search Engine Optimization doesn't have to feel daunting for creatives. By focusing on intent-driven keywords and clean page hierarchy, you can consistently attract ideal clients.",
      "Structure your service pages with explicit headings, descriptive alt tags for images, and fast-loading media to boost your search rankings."
    ]
  },
  {
    id: 'client-spotlight-custom-brand-launch',
    slug: 'client-spotlight-custom-brand-launch',
    title: 'Client Spotlight: Crafting an Organic Luxury Brand for Botanica Studio',
    category: 'CLIENT STORIES',
    date: 'JUNE 20, 2026',
    featuredImage: about1Img,
    excerpt: 'Behind the scenes of transforming Botanica Studio into a premium brand experience that doubled their online inquiries.',
    content: [
      "Botanica Studio came to us needing a digital refresh that reflected their organic, sustainable ethos while attracting high-end commercial clients.",
      "We created a custom Showit layout with soothing earthy tones, smooth micro-animations, and strategic inquiry touchpoints."
    ]
  },
  {
    id: 'why-showit-is-the-ultimate-platform-for-designers',
    slug: 'why-showit-is-the-ultimate-platform-for-designers',
    title: 'Why Showit is the Ultimate Platform for Creative Service Providers',
    category: 'DESIGN',
    date: 'MAY 10, 2026',
    featuredImage: web4Img,
    excerpt: 'Explore why Showit offers unmatched creative freedom, effortless mobile customization, and seamless WordPress blogging integration.',
    content: [
      "Showit combines drag-and-drop design freedom with the powerful blogging backend of WordPress, making it the top choice for modern creative entrepreneurs.",
      "Build stunning custom layouts without code barriers while retaining complete control over responsive breakpoint displays."
    ]
  },
  {
    id: 'building-a-mindful-morning-routine-for-entrepreneurs',
    slug: 'building-a-mindful-morning-routine-for-entrepreneurs',
    title: 'Building a Mindful Morning Routine to Fuel Your Creative Work',
    category: 'WELLNESS',
    date: 'APRIL 05, 2026',
    featuredImage: contact1Img,
    excerpt: 'Cultivate intentional habits that reduce burnout, sharpen focus, and invite calm into your daily business workflow.',
    content: [
      "Starting your morning with quiet reflection and light movement transforms your energetic output throughout the workday.",
      "Swap early phone scrolling for ten minutes of meditation or journaling to begin your day with clarity and purpose."
    ]
  },
  {
    id: 'august-wallpaper-collection-golden-hour-moments',
    slug: 'august-wallpaper-collection-golden-hour-moments',
    title: 'August Wallpaper Collection: Golden Hour & Quiet Moments',
    category: 'WALLPAPER',
    date: 'MARCH 12, 2026',
    featuredImage: contact4Img,
    excerpt: 'Download our latest series of warm golden-hour iPhone wallpapers designed to inspire daily mindful pauses.',
    content: [
      "Soak in the late summer sun with our curated August wallpaper series, featuring warm neutral tones and serene botanical close-ups."
    ]
  },
  {
    id: 'pricing-your-creative-services-with-confidence',
    slug: 'pricing-your-creative-services-with-confidence',
    title: 'Pricing Your Creative Services with Confidence and Clarity',
    category: 'BUSINESS',
    date: 'FEBRUARY 20, 2026',
    featuredImage: web5Img,
    excerpt: 'Learn how to package your service offerings, set profitable rates, and communicate your value seamlessly.',
    content: [
      "Pricing your services isn't just about cover costs — it reflects your expertise, client transformation, and sustainable business growth."
    ]
  },
  {
    id: 'the-power-of-minimalist-web-design',
    slug: 'the-power-of-minimalist-web-design',
    title: 'The Power of Minimalist Web Design in Modern Brand Building',
    category: 'DESIGN',
    date: 'JANUARY 15, 2026',
    featuredImage: web6Img,
    excerpt: 'Why subtle typography, intentional white space, and refined aesthetics create unforgettable user experiences.',
    content: [
      "Minimalism in digital design is about intentional clarity. Stripping away visual noise allows key content and brand stories to shine brightly."
    ]
  },
  {
    id: 'how-to-optimize-images-for-fast-website-speed',
    slug: 'how-to-optimize-images-for-fast-website-speed',
    title: 'How to Optimize Images for Fast Loading Times without Losing Quality',
    category: 'SEO',
    date: 'DECEMBER 10, 2025',
    featuredImage: process1Img,
    excerpt: 'Compress and resize high-resolution portfolio images to deliver lightning fast page loads and boost SEO rankings.',
    content: [
      "Large image files are the primary cause of slow site load times. Learn the ideal dimensions and file formats (WebP, JPEG) for web graphics."
    ]
  },
  {
    id: 'behind-the-design-elevated-aesthetic-for-salt-spruce',
    slug: 'behind-the-design-elevated-aesthetic-for-salt-spruce',
    title: 'Behind the Design: An Elevated Aesthetic for Salt & Spruce Studio',
    category: 'CLIENT STORIES',
    date: 'NOVEMBER 05, 2025',
    featuredImage: process2Img,
    excerpt: 'A complete brand and web design walkthrough for a wellness interior design consultancy.',
    content: [
      "We partnered with Salt & Spruce to build a quiet luxury website showcasing their portfolio of sustainable architectural spaces."
    ]
  },
  {
    id: 'autumn-wallpaper-collection-cozy-textures',
    slug: 'autumn-wallpaper-collection-cozy-textures',
    title: 'Autumn Wallpaper Collection: Cozy Textures & Warm Earth Tones',
    category: 'WALLPAPER',
    date: 'OCTOBER 12, 2025',
    featuredImage: about3Img,
    excerpt: 'Seasonal phone background wallpapers featuring rich linen textures, cozy mugs, and warm neutral palettes.',
    content: [
      "Bring autumn warmth to your device with our minimalist phone wallpaper collection."
    ]
  },
  {
    id: 'incorporating-holistic-wellness-into-your-workday',
    slug: 'incorporating-holistic-wellness-into-your-workday',
    title: 'Incorporating Holistic Wellness Practices into Your Daily Workday',
    category: 'WELLNESS',
    date: 'SEPTEMBER 01, 2025',
    featuredImage: about2Img,
    excerpt: 'Simple ergonomic adjustments, breathwork prompts, and hydration routines for desk-bound professionals.',
    content: [
      "Small daily pauses improve posture, enhance focus, and keep creative energy flowing smoothly throughout long work sessions."
    ]
  },
  {
    id: 'mastering-custom-canvas-views-in-showit',
    slug: 'mastering-custom-canvas-views-in-showit',
    title: 'Mastering Custom Canvas Views and Mobile Layouts in Showit',
    category: 'DESIGN',
    date: 'AUGUST 15, 2025',
    featuredImage: web1Img,
    excerpt: 'Step-by-step tips to create interactive tabbed sliders, mobile menus, and dynamic views on Showit.',
    content: [
      "Canvas views allow you to display multiple interactive tabs or slides within a single canvas section seamlessly."
    ]
  }
];
